import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue';
import BDListBlock from 'bd-common/src/components/list/BDListBlock.vue';
import { BhMenuItem } from 'bd-common/src/components/common/menus/BhBaseMenu.vue';
import DropdownMenu, { DropdownMenuItem } from 'bd-common/src/components/common/DropdownMenu.vue';
import { VButton } from 'ah-common-lib/src/common/components';
import ViewTabsMenu from 'bd-common/src/components/common/menus/ViewTabsMenu.vue';
import CardCornerMenu from 'bd-common/src/components/common/menus/CardCornerMenu.vue';
import SearchFilter from 'bd-common/src/components/form/SearchFilter.vue';
import { useQueryParamRef } from 'ah-common-lib/src/helpers/useQueryParam';
import {
  invitedClientsTableFields,
  onboardedClientsTableFields,
} from '@/app/components/inviteClients/inviteClientsListingTableFields';
import InviteSingleClientModal from '@/app/components/inviteClients/InviteSingleClientModal.vue';
import ClientsListFilter from '@/app/components/inviteClients/ClientsListFilter.vue';
import { ClientOnboardingReport, PaginatedParams } from 'ah-api-gateways';
import InvitedClientsListing from '@/app/components/inviteClients/InvitedClientsListing.vue';
import OnboardedClientsListing from '@/app/components/inviteClients/OnboardedClientsListing.vue';
import { useRouter } from 'vue-router/composables';
import { cloneDeep } from 'lodash';

type ViewMenuItem = (typeof viewMenuKeys)[number];

type ClientMenuItem = (typeof clientMenuKeys)[number];


export default /*#__PURE__*/_defineComponent({
  __name: 'ClientsView',
  setup(__props) {

const inviteClientModal = ref<InstanceType<typeof InviteSingleClientModal>>();
const clientsListBlock = ref<InstanceType<typeof BDListBlock>>();
const clientsListing = ref<InstanceType<typeof InvitedClientsListing> | InstanceType<typeof OnboardedClientsListing>>();

const viewMenuKeys = ['clients', 'limits'] as const;

const clientMenuKeys = ['invited', 'onboarded'] as const;

const router = useRouter();

const viewMenuItems: BhMenuItem[] = [
  { label: 'Client List', value: 'clients', icon: 'format_list_bulleted' },
  { label: 'Limits', value: 'limits', icon: 'show_chart' },
];

const clientsMenuItems: BhMenuItem[] = [
  { label: 'Invited', value: 'invited', icon: 'radio_button_partial' },
  { label: 'Onboarded', value: 'onboarded', icon: 'task_alt' },
];

const dropdownMenuItems: DropdownMenuItem[] = [
  { name: 'inviteSingleClient', label: 'Invite Single Client', action: showInviteSingleClientModal },
  { name: 'inviteMultipleClients', label: 'Invite Multiple Clients', action: () => {} },
];

const selectedMenu = useQueryParamRef<ViewMenuItem>('tab', 'clients', {
  deserialize(param) {
    if (!viewMenuKeys.includes(param as ViewMenuItem)) {
      return 'clients';
    }
    return param as ViewMenuItem;
  },
});

const selectedSubMenu = useQueryParamRef<ClientMenuItem>('clients-tab', 'invited', {
  deserialize(param) {
    if (!clientMenuKeys.includes(param as ClientMenuItem)) {
      return 'invited';
    }
    return param as ClientMenuItem;
  },
});

const clientsMenuItemsLabel = computed(() => {
  return clientsMenuItems.find((item) => item.value === selectedSubMenu.value)?.label;
});

const getCustomHeading = (hasCustomFilters: boolean | undefined, filter: any) => {
  if (hasCustomFilters) {
    return filter?.query
      ? `We couldn’t find search results for ${filter.query}`
      : 'We couldn’t find results matching your filter(s)';
  } else {
    return `There are no ${clientsMenuItemsLabel.value} clients to show`;
  }
};

const getWarningSubHeading = (hasCustomFilters: boolean | undefined, filter: any) => {
  if (hasCustomFilters) {
    return filter.query ? 'Please clear or try another search' : 'Please clear or try other filters';
  } else {
    return selectedSubMenu.value === 'invited'
      ? 'Once you invite new clients, they will appear here'
      : 'Once clients complete the full onboarding process, they will appear here';
  }
};

// defaultSortAndPageParams is purposefully not reactive, so as to not trigger any change detection
const defaultSortAndPageParams: Partial<PaginatedParams> = {
  sort: 'createdAt',
  sortDirection: 'DESC',
};

const listConfig = computed(() => {
  return {
    tableFields: selectedSubMenu.value === 'invited' ? invitedClientsTableFields : onboardedClientsTableFields,
  };
});

function showInviteSingleClientModal() {
  inviteClientModal.value?.show();
}

function refreshList() {
  clientsListing.value?.loadData(undefined, true);
}

function onSelectedSubMenuChange(newVal: string) {
  if (clientsListBlock.value) {
    clientsListBlock.value.managedListBlock.refs.sortAndPageParams.value = cloneDeep(defaultSortAndPageParams);
    clientsListBlock.value.managedListBlock.refs.filter.value = undefined;
  }
  selectedSubMenu.value = newVal as ClientMenuItem;
}

function onViewClient(client: ClientOnboardingReport) {
  router.push(`./clients/${client.id}`);
}

const downloadFormatOptions = [
  { value: 'XLSX', text: 'Excel' },
  { value: 'CSV', text: 'CSV' },
];

return { __sfc: true,inviteClientModal, clientsListBlock, clientsListing, viewMenuKeys, clientMenuKeys, router, viewMenuItems, clientsMenuItems, dropdownMenuItems, selectedMenu, selectedSubMenu, clientsMenuItemsLabel, getCustomHeading, getWarningSubHeading, defaultSortAndPageParams, listConfig, showInviteSingleClientModal, refreshList, onSelectedSubMenuChange, onViewClient, downloadFormatOptions, BDListBlock, DropdownMenu, VButton, ViewTabsMenu, CardCornerMenu, SearchFilter, InviteSingleClientModal, ClientsListFilter, InvitedClientsListing, OnboardedClientsListing }
}

})